import { useLocation } from 'react-router-dom';

const useParams = () => {
  const location = useLocation();
  const path = location.pathname;

  const workoutMatch = path.match(/\/workout\/([^/]+)/);
  if (workoutMatch) {
    return { workoutId: workoutMatch[1] };
  }

  const sessionMatch = path.match(/\/session\/([^/]+)/);
  if (sessionMatch) {
    return { sessionId: sessionMatch[1] };
  }

  return {};
};

export default useParams;
